import { render, staticRenderFns } from "./PDFGenerator.vue?vue&type=template&id=354236ac&scoped=true"
import script from "./PDFGenerator.vue?vue&type=script&lang=ts"
export * from "./PDFGenerator.vue?vue&type=script&lang=ts"
import style0 from "./PDFGenerator.vue?vue&type=style&index=0&id=354236ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354236ac",
  null
  
)

export default component.exports